var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-main-content-wrap" },
    [
      _vm.isCompanyStaffAccess
        ? _c("setting-header", {
            staticClass: "hide-for-print",
            attrs: {
              breadcrumbs: [
                { name: "求人確認" },
                { name: "掲載前の求人", pathName: "jobPrePublished" },
              ],
              title: "掲載前の求人プレビュー_企業情報",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pega-option-wrap" },
        [
          _c(
            "div",
            { staticClass: "grid-x hide-for-print" },
            [
              _c(
                "div",
                { staticClass: "cell auto" },
                [
                  _c("sp-preview-button", {
                    attrs: {
                      id: _vm.id,
                      "route-name": _vm.spRouteNameForCompany,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("print-button", { staticClass: "cell shrink" }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pega-text-small" }, [
            _vm._v(
              "\n      ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。\n    "
            ),
          ]),
          _vm._v(" "),
          _c("company-preview-detail", {
            attrs: {
              "is-light-plan": _vm.isLightPlan,
              "company-info": _vm.companyInfo,
              report: _vm.report,
              environment: _vm.environment,
            },
          }),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("company-supplement-preview", {
            attrs: { "company-supplement-info": _vm.companySupplementInfo },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "margin-top-1 pega-hide-msg" }, [
      _vm._v(
        "\n      これ以降は、女の転職typeのユーザー画面では表示されません。ただし、提携サイトには表示される場合がございます。"
      ),
      _c("br"),
      _vm._v("\n      あらかじめご了承ください。\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }